





























































































































import {Component, Vue} from 'vue-property-decorator';
import {ObjectFactory} from '../../config/objectFactory';
import {UpdateMemberRequest} from '../../types/request';
import {validationMixin} from 'vuelidate';
import {email, integer, minLength, required} from 'vuelidate/lib/validators';
import {MedTransGoConstants} from '../../util/constants';
import {ToastEvent} from '../../types/event';
import {CommonUtils} from '../../util/commonUtils';
import {EventBus} from '../../main';
import {OrgLocation} from '../../types/entity';
import {MemberLocation, MemberProfile} from '@/types/response';

@Component({
    mixins: [validationMixin],
    data() {
        return {
            fullName: '',
            email: '',
            phone: '',
            location: '',
            managedLocations: [],
            memberType: '',
            maximumAllowedSubmission: 0,
            isRequestLimit: false,
            isRestrictedView: false,
            isApprovalRequired: false,
        };
    },
    validations() {
        const rules = {
            fullName: {
                required,
                regex: (fullName: string) => /^[a-zA-Z ]+$/.test(fullName),
            },
            email: {
                required,
                email,
            },
            phone: {
                required,
                minLength: minLength(10),
                regex: (phone: string) => MedTransGoConstants.PHONE_REGX.test(phone),
            },
            location: {
                required,
            },
            managedLocations: {},
            memberType: {
                required,
            },
            maximumAllowedSubmission: {
                required,
                integer,
            },
        };
        if ((!this.$data.isRequestLimit && this.$data.memberType === 'ORG_CUSTOMER') || this.$data.memberType !== 'ORG_CUSTOMER') {
            delete rules.maximumAllowedSubmission;
        }
        return rules;
    },
})
export default class UpdateMemberModal extends Vue {
    private show = false;
    private member: MemberProfile = {} as any;
    private locations: OrgLocation[] | undefined = [];
    private isLienEnabled = false;
    private isMemberType = false;
    public mounted() {
        this.member = ObjectFactory.getCacheService().getMemberInfo();
        if (this.member && this.member.memberType === 'ORG_MANAGER') {
            this.isMemberType = true;
        }
        this.getOrganizationLocations();
        this.getMemberDetails(this.$route.params.id);
        this.getOrganization();
    }

    private async getMemberDetails(memberId: any) {
        const response = await ObjectFactory.getMemberService().getMemberDetails(this.$store.state.serverUrl,
            memberId);
        if (response.success && response.data) {
            this.member = response.data;
            this.$data.fullName = this.member.fullname;
            this.$data.email = this.member.email;
            this.$data.phone = this.member.phone;
            this.$data.memberType = this.member.memberType;
            this.$data.isRestrictedView = this.member.isRestrictedView ? this.member.isRestrictedView : false;
            if (response.data.memberType === 'ORG_MEMBER') {
                this.$data.isApprovalRequired = this.member.isApprovalRequired;
            }
            if (this.member.location) {
                this.$data.location = this.member.location.id;
            }
            if (Array.isArray(this.member.managedLocations) && this.member.managedLocations.length > 0) {
                this.$data.managedLocations = this.member.managedLocations.map(
                    (ml: MemberLocation) => ({id: ml.id, locationName: ml.name}),
                );
            } else {
                this.$data.managedLocations = this.member.location ? [{
                    id: this.member.location.id,
                    locationName: this.member.location.name,
                }] : [];
            }
            this.$data.maximumAllowedSubmission = this.member.maximumAllowedSubmission;
            if (this.member.maximumAllowedSubmission) {
                this.$data.isRequestLimit = true;
            }
            this.show = true;
        } else {
            CommonUtils.showError(response);
        }
    }

    private async getOrganization() {
        const organization = await ObjectFactory.getOrganizationService().
        getOrgDetailsById(this.$store.state.serverUrl);
        if (organization && organization.data && organization.data.lienCustomerEnabled) {
            this.isLienEnabled = true;
        }
    }

    private async updateMember() {
        const updateMemberRequest: UpdateMemberRequest = {
            fullname: this.$data.fullName,
            email: this.$data.email,
            phone: this.$data.phone,
            location: this.$data.location,
            managedLocationIds: this.$data.managedLocations.map((ml: OrgLocation) => ml.id),
            memberType: this.$data.memberType,
            maximumAllowedSubmission: this.$data.maximumAllowedSubmission,
            isRestrictedView: this.$data.isRestrictedView,
            isApprovalRequired: this.$data.isApprovalRequired,
        };
        if (this.$data.memberType !== 'ORG_CUSTOMER') {
            delete updateMemberRequest.maximumAllowedSubmission;
        }
        if (this.$data.memberType !== 'ORG_MEMBER') {
            delete updateMemberRequest.isApprovalRequired;
        }
        const response = await ObjectFactory.getMemberService().updateMember(this.$store.state.serverUrl,
            this.$route.params.id, updateMemberRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_UPDATE_MEMBER'),
                title: 'Success!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$router.push({ name: MedTransGoConstants.VIEW_SETTING_NAME });
        } else {
            CommonUtils.showError(response);
        }
    }

    /**
     * @author <Aniket.P>
     * @description API - Returns organization locations
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - list of locations
     * @returns List of oragnazation lists
     * @throws InvalidRequestException if organization id is invalid
     */
    private async getOrganizationLocations() {
        if (!this.locations || this.locations.length <= 0) {
            const memberProfile = ObjectFactory.getCacheService().getMemberInfo();
            if (memberProfile.organization) {
                const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
                if (response.success) {
                    this.locations = response.data;
                } else {
                    CommonUtils.showError(response);
                }
            }
        }
    }

    private async togglePermission() {
        this.$data.isRestrictedView = !this.$data.isRestrictedView;
    }

    private close() {
        this.$router.push({
            name: MedTransGoConstants.VIEW_SETTING_NAME,
        });
    }

    private handleChangeLocation(event: any) {
        const location = (this.locations || []).find((loc: OrgLocation) => loc.id === event.target.value);
        if (location) {
            this.$data.managedLocations = [{
                id: location.id,
                locationName: location.locationName,
            }];
        }
    }
}
